// -----------------------------------------------------------------------------
// Application Route Path Constants
// Centralized route paths shared across modules (route guards, navigation,
// page-context maps, etc.). Reuses PAIC_ROUTES for the People + AI paths so
// there is a single source of truth for every module's path strings.
// -----------------------------------------------------------------------------

import { PAIC_ROUTES } from "constants/paicRoutes.constants";

export const APP_ROUTES = {
  DASHBOARD: "/dashboard",

  JOBS_LIBRARY: "/jobs-library",
  JOB_DETAILS: "/jobs-library/job-details",

  PEOPLE_AI: PAIC_ROUTES.MAIN,
  PAIC_GROUP_AGENTS: PAIC_ROUTES.GROUP_AGENTS,
  PAIC_AGENT_DETAILS: PAIC_ROUTES.AGENT_DETAILS,
  PAIC_ROLE_IMPACT: PAIC_ROUTES.ROLE_IMPACT,

  SKILLS_BRIDGER: "/skills-bridger",
  SKILLS_MAP: "/skills-bridger/skills-map",
  GROUP_SKILLS_MAP: "/skills-bridger/group-skills-map",
  EMPLOYEE_SKILLS_MAP: "/skills-bridger/employee-skills-map",

  // Admin Console (admin-only). Child pages (/admin-setup/*) resolve to this
  // via prefix matching in SbAssistConfig.
  ADMIN_SETUP: "/admin-setup",
  SYSTEM_ADMIN_SETUP: "/system-admin-setup",
};
